module.exports = __webpack_public_path__ + "img/back_neck_depth.c5a82204.png";